import TimetableSlot from '../timetable/timetableSlot';
import BattleshipMove from './battleshipMove';

interface DefaultState {
    departments: Array<any>;
    departmentSelected: Array<any>;
    allDepartments: Array<any>;

    sets: Array<any>;
    setsSelected: Array<any>;
    allSets: Array<any>;

    instructors: Array<any>;
    instructorsTo: Array<any>;

    instructorsSelectedFrom: Array<any>;
    instructorsSelectedTo: Array<any>;
    allInstructors: Array<any>;

    buildings: Array<any>;
    buildingsTo: Array<any>;
    buildingSelectedFrom: Array<any>;
    buildingSelectedTo: Array<any>;
    allBuildings: Array<any>;

    rooms: Array<any>;
    roomsTo: Array<any>;
    roomsSelectedFrom: Array<any>;
    roomsSelectedTo: Array<any>;
    allRooms: Array<any>;

    changeIndex: number;
    baseObjectID: number | null;
    baseObjectTypeID: number | null;
    timetableFrom: any;
    timetableSelectedItem: any;
    timetableTo: any;
    timetablePendingChange: BattleshipMove | null;
    timetableMoves: Array<BattleshipMove>;

    isSandboxEnabled: boolean;
    changesToExportExcel: Array<any>;
    view: number;
    hasSandboxReset: boolean;
    loader: boolean;

    openDepartmentDialog: false;
    multiplePrintType: string;

    subjects: Array<any>;
    printMenu: any;

    isLoading: boolean;
    openPrintDialog: boolean;

    step: number;

    setTimetables: Array<any>;
    instructorTimetables: Array<any>;

    emptySlots: Array<TimetableSlot>;

    changesFrom: Array<any>;
    setInstructors: Array<any>;
}

const defaultState: DefaultState = {
    departments: [],
    departmentSelected: [],
    allDepartments: [],

    sets: [],
    setsSelected: [],
    allSets: [],

    instructors: [],
    instructorsTo: [],

    instructorsSelectedFrom: [],
    instructorsSelectedTo: [],
    allInstructors: [],

    buildings: [],
    buildingsTo: [],
    buildingSelectedFrom: [],
    buildingSelectedTo: [],
    allBuildings: [],

    rooms: [],
    roomsTo: [],
    roomsSelectedFrom: [],
    roomsSelectedTo: [],
    allRooms: [],

    changeIndex: 0,
    baseObjectID: null,
    baseObjectTypeID: null,
    timetableFrom: null,
    timetableSelectedItem: null,
    timetableTo: null,
    timetablePendingChange: null,
    timetableMoves: [],

    isSandboxEnabled: false,
    changesToExportExcel: [],
    view: 12,
    hasSandboxReset: false,
    loader: false,

    openDepartmentDialog: false,
    multiplePrintType: '',

    subjects: [],
    printMenu: null,

    isLoading: true,
    openPrintDialog: false,

    step: 0,

    setTimetables: [],
    instructorTimetables: [],

    emptySlots: [],

    changesFrom: [],
    setInstructors: [],
};

export default defaultState;
